/* eslint-disable */

import {
  bus
} from '@/main';

const $ = window.jQuery = require('jquery');  
export default {
  name: 'contact-us',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {
    bus.$emit('showHeaderbtn', false);
  },
  methods: {

  },
  beforeCreate: function() {
    $('body').addClass('contact_us_page_wrp')
    $('body').addClass('left_sidebaar_disabled_for_page')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('contact_us_page_wrp')
    next();
  },
}